import { fillFormDemo } from '@/pages/api/scribeAPIV2';
import { type FillFormDemoRequest, type FillFormDemoResponse } from '@/types';
import { useMutation } from '@tanstack/react-query';

export const DEMO_FILL_FORM_MUTATION_KEY = ['demo-fill-form'] as const;

export function useMutateFillFormDemo() {
  return useMutation<FillFormDemoResponse, Error, FillFormDemoRequest>({
    mutationKey: DEMO_FILL_FORM_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillFormDemo(request);
      return data;
    },
  });
}
